import type { ReactNode } from 'react';
import { Card, Flex, Skeleton, Tag, Tooltip, Typography } from 'antd';

export type StatTone = 'neutral' | 'positive' | 'negative';

const TONE_COLOR: Record<StatTone, string | undefined> = {
  neutral: undefined,
  positive: 'var(--color-success)',
  negative: 'var(--color-danger)',
};

export interface StatCardProps {
  label: ReactNode;
  /** Already formatted value (e.g. `<Money />`). */
  children: ReactNode;
  /** Explanation shown on hover over the label. */
  hint?: string;
  /** Small badge next to the label, e.g. «оценка»; the text must be translated by the caller. */
  tag?: string;
  tone?: StatTone;
  loading?: boolean;
}

/** A single summary figure: label on top, big value below. */
export function StatCard({
  label,
  children,
  hint,
  tag,
  tone = 'neutral',
  loading = false,
}: StatCardProps) {
  const caption = <Typography.Text type="secondary">{label}</Typography.Text>;
  return (
    <Card size="small" style={{ height: '100%' }}>
      <Flex vertical gap={4}>
        <Flex align="center" gap={8} wrap="wrap">
          {hint ? <Tooltip title={hint}>{caption}</Tooltip> : caption}
          {tag ? <Tag color="warning">{tag}</Tag> : null}
        </Flex>
        {loading ? (
          <Skeleton.Input active size="small" />
        ) : (
          <Typography.Text strong style={{ fontSize: 20, color: TONE_COLOR[tone] }}>
            {children}
          </Typography.Text>
        )}
      </Flex>
    </Card>
  );
}
